import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import breakpoints from '../../utils/breakpoints';
const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.TwoColumnVideo-root': {
						marginBottom: remCalc(50),

						'&.padding-normal': {
							paddingTop: remCalc(20),
							paddingBottom: remCalc(20),
							[theme.breakpoints.up('sm')]: {
								paddingTop: remCalc(100),
								paddingBottom: remCalc(100),
							},
						},

						'&.margin-flush': {
							marginBottom: 0,
						},

						
						'.TwoColumnVideo-thumbnailContainer': {
							position: 'relative',
							overflow: 'hidden',
							width: '100%',
							height: '100%',
							borderRadius: '11px',
							cursor: 'pointer',
							'*': {
								borderRadius: '11px',
							},
						},
						
						'.TwoColumnVideo-buttonContainer': {
							zIndex: 2,
							position: 'absolute',
							marginTop: '-18px',
							transform: 'translateY(-100%)',
							right: remCalc(40),
							[theme.breakpoints.up('sm')]: {
								right: remCalc(16),
							},
							button: {
								margin: 0,
								padding: 0,
							}
						},

						'.TwoColumnVideo-videoLoop': {
							video: {
								width: '100%',
								height: '100%',
							}
						}
					},
				},
			},
		},
	},
}

export default styles;